let port = "";
if (window.location.port){
  port = ":8082";
}
export const SERVER_URL = `${window.location.protocol}//${window.location.hostname}${port}`;
//export const SERVER_URL = "http://mushroom-x.demo.digiec.com";
//export const SERVER_URL = "http://192.168.86.94:8080";
//export const SERVER_URL = "http://192.168.86.117:8080";
//export const SERVER_URL = "http://10.1.0.187:8080";
